import State from "./state"

export function setParentTotalPoints(state, total) {
  state.parent_total_points = total
}

export function setParentPointsSum(state, data) {
  state.parent_points_sum = data
}

export function setParentPointsMean(state, data) {
  state.parent_points_mean = data
}

export function setChildPoints(state, data) {
  let aux = state.child_points
  state.child_points = {}
  state.child_points = aux
  state.child_points[data.id] = data.data

}

export function setChildGoalsApproved(state, data) {
  let aux = state.child_goals
  state.child_goals = {}
  state.child_goals = aux
  state.child_goals[data.id] = data.data
}

export function setChildUniquePoints(state, data) {
  state.child_unique_points = data.data
}

export function setParentPointBySkill(state, data){
  state.parent_point_by_skill = data
}

export function setParentPointPerTime(state,data){
  state.parent_points_per_time = data
}

export function SetChildStars(state,data){
  state.child_star_progress = data
}

export function setStarsProgressById(state, { data, childId }) {
  const aux = JSON.parse(JSON.stringify(state.child_star_progress));
  const index = aux.findIndex((progress) => progress.child === childId);

  aux[index] = data;
  state.child_star_progress = aux;
}

export function SetChildGoals(state,data){
  state.child_goals_progress = data
}

export function SetChildOwnStars(state,data){
  state.child_own_stars = data
}

export function setProgressPopups(state = State, data){
  state.popups.parent = {...data.parent}
  state.popups.child = {...data.child}
}

export function cleanErrors(state) {
  state.error = false
  state.errorMessage = ''
}

export function error(state, error) {
  console.log("errorcatch", error)
  state.error = true
  state.errorMessage = error
}
